const mapping = {
	zh_TW: 'zh-TW',
	zh_MO: 'zh-TW',
	zh_HK: 'zh-TW',
	zh_CN: 'zh-CN',
	ja: 'ja-JP',
	en_US: 'en-US',
	en_SG: 'en-US',
	en_PH: 'en-US',
	en_MY: 'en-US',
	en_IN: 'en-US',
	en_AU: 'en-US',
	en_AE: 'en-US',
	en_GB: 'en-GB',
}

function getLocale(lang: string) {
	const locale = mapping[lang as keyof typeof mapping]
	return locale === undefined ? 'en-US' : locale
}

export function getMonth(input: number | string, locale = 'en_US') {
	const objDate = new Date()
	objDate.setDate(1)
	objDate.setMonth(Number(input) - 1)

	return objDate.toLocaleString(getLocale(locale), { month: 'short' })
}

export function getInfoBoxContent(param: {
	fulfillmentMode: string
	fulfillmentRange: string
	fulfillmentMonth: string
	fulfillmentMaxOrderPerUser: number
	fulfillmentMaxQuantity: number
	isOutOfStock: boolean
	text: any
}) {
	const {
		fulfillmentMode,
		fulfillmentRange,
		fulfillmentMonth,
		isOutOfStock,
		text,
	} = param

	if (isOutOfStock) {
		return {
			title: text.infobox.title.soldOut,
			description: text.infobox.description.soldOut,
		}
	}

	const mapTitle = {
		'group-buying-presell': 'preOrder',
		'group-buying-instock': 'inStock',
		'group-buying-presell-month': 'preOrderGroupMonth',
		'group-buying-presell-date': 'preOrderGroupDate',
		'group-buying-instock-date': 'preOrderGroupWithStock', // 團購現貨商品
		'group-buying-instock-limit': 'preOrderGroupWithLimited', // 團購限量商品
		'group-buying-instock-date-3-5': 'preOrderGroupWithThreeToFiveDays',
	}

	const mapDescription = {
		'group-buying-presell': 'preOrder',
		'group-buying-instock': 'inStock',
		'group-buying-presell-month': 'preOrderGroupMonth',
		'group-buying-presell-date': 'preOrderGroupDate',
		'group-buying-instock-date': 'preOrderGroupWithStock', // 團購現貨商品
		'group-buying-instock-limit': 'preOrderGroupWithLimited', // 團購限量商品
		'group-buying-instock-date-3-5': 'preOrderGroupWithThreeToFiveDays',
	}

	const title =
		text.infobox.title[mapTitle[fulfillmentMode as keyof typeof mapTitle]]
	let description =
		text.infobox.description[
			mapDescription[fulfillmentMode as keyof typeof mapDescription]
		]

	if (fulfillmentMode === 'group-buying-presell-month') {
		description = description
			.replace(
				'{month}',
				getMonth(fulfillmentMonth, window.BUYANDSHIP.settings.current_language),
			)
			.replace('{monthRange}', text.infobox.monthRange[fulfillmentRange])
	}

	if (fulfillmentMode === 'group-buying-instock-limit') {
		description = description
			.replace('{maxOrder}', param.fulfillmentMaxOrderPerUser)
			.replace('{max}', param.fulfillmentMaxQuantity)
	}

	return {
		title,
		description,
	}
}
